@if (cancelBenefit) {
  <div class="mb-3 message-card red">
    <!-- <mwp-text-translate text="Listed below are the requests that will be terminated based on your new elections. Clicking confirm will remove the requests from the system." jsonKey="requestTermNote" /> -->
    <mwp-text-translate text="Listed below are the requests that will be cancelled based on your new elections. Clicking confirm will remove the requests from the system." jsonKey="CancelRequestNote" />
  </div>
}
<div class="content-container table-comp mb-3">
  @if (cancelBenefit) {
    <div class="title">
      <mwp-text-translate text="Cancel Benefits" jsonKey="cancelBenefits" /> 
      <!-- <mwp-text-translate text="Terminate Benefits" jsonKey="terminateBenefits" /> -->
    </div>
    <div class="content">
      <mwp-table [tableColumns]="cancelBenefitColumns" [dataSource]="cancelBenefitData"></mwp-table>
    </div>
  }
  <div class="footer">
    <mwp-benefit-enrollment-wizard-control (emitComplete)="submitTermComplete()"></mwp-benefit-enrollment-wizard-control>
  </div>
</div>
